export enum InvoicingPeriod {
    PER_SALE   = 'sale',
    PER_DAY    = 'day',
    PER_WEEKLY = 'weekly',
    PER_MONTH  = 'month'
}